import { Context, type Effect, Layer, type Scope } from "effect";
import type { ChatScrollFailure, ChatScrollSnapshot } from "./scroll-model.ts";

export class ChatScrollIo extends Context.Service<ChatScrollIo, {
  readonly measure: (target: HTMLElement) => Effect.Effect<unknown, ChatScrollFailure>;
  readonly bottom: (target: HTMLElement) => Effect.Effect<void, ChatScrollFailure>;
}>()("workerstation/frontend/ChatScrollIo") {}
export const ChatScrollIoTest = (io: typeof ChatScrollIo.Service) => Layer.succeed(ChatScrollIo, io);
export interface ChatScrollSession {
  readonly read: Effect.Effect<ChatScrollSnapshot>;
  readonly receive: (target: HTMLElement | null, version: object) => Effect.Effect<void>;
  readonly scrolled: (target: HTMLElement) => Effect.Effect<void>;
  readonly resume: Effect.Effect<void>;
}
export class ChatScrollSessions extends Context.Service<ChatScrollSessions, {
  readonly open: Effect.Effect<ChatScrollSession, never, Scope.Scope>;
}>()("workerstation/frontend/ChatScrollSessions") {}
